export interface DeleteOrderListSelectionRequest {
  listId: string
  selectionId: string
  revision: number
}

export function DeleteOrderLIstSelectionRequestToJSON(
  value: DeleteOrderListSelectionRequest
): any {
  return {
    list_id: value.listId !== '' ? value.listId : undefined,
    selection_id: value.selectionId !== '' ? value.selectionId : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
